import React from "react";
import { useTranslation } from "react-i18next";
import { ownerInitials, ownerLabel } from "../lib/ownerDisplay";

/**
 * Compact owner badge: initials avatar + name.
 * Renders "Неразпределена" pill when owner is null.
 * Used in quotation lists, detail pages, and dashboard rows.
 */
export default function OwnerBadge({ owner, small = false, testid }) {
  const { t } = useTranslation();
  const label = ownerLabel(owner, t);
  if (!owner) {
    return (
      <span
        className={`qw-owner-pill unassigned${small ? " sm" : ""}`}
        data-testid={testid || "owner-badge-unassigned"}
      >
        {label}
      </span>
    );
  }
  const inactive = owner.is_active === false;
  return (
    <span
      className={`qw-owner-pill${inactive ? " inactive" : ""}${small ? " sm" : ""}`}
      data-testid={testid || `owner-badge-${owner.user_id}`}
    >
      <span className="qw-owner-avatar" aria-hidden="true">
        {ownerInitials(owner)}
      </span>
      <span className="qw-owner-name">{label}</span>
    </span>
  );
}
